var common = require("./common.js");
var deepCopy = common.deepCopy;
var core = require("./EHcore.js");
var Calcu_24 = core.Calcu_24
var Calcu_04 = core.Calcu_04
var Calcu_45 = core.Calcu_45
var calcE = core.calcE
var calcOstatus = core.calcOstatus
var calcOstatus2 = core.calcOstatus2
var calcL2status = core.calcL2status
var calcG = core.calcG
var calcQ = core.calcQ
var calcC = core.calcC
var calcC2 = core.calcC2
var calcC3 = core.calcC3
var calcRat = core.calcRat

var calcuMethods = [
	{
		name: '一次回风',
		lable: '冬夏',
		desc: '一次回风计算方法，可以同时计算冬夏季的处理过程。冬夏季采用相同的总风量。',
		selected: false,
		calcu: function (inputParm_s_default, inputParm_w_default, atm) {
			console.log('一次回风atm=', atm);
			var res = this.calcuSummer(inputParm_s_default, atm);
			if (res) {
				var g = res.G;//夏季风量
				this.calcuWinter(inputParm_w_default, g, atm);
			}
		},
		//计算夏季
		inputSummberParm: {
			desc: '一次回风夏季补充输入',
			selected: true,
			isActive: false,
			value: {
				plan: {
					desc: '方案', type: 'select', selected: 'dT', value: {
						dT: { value: 2, unit: '℃', conversion: 1, step: 0.01, min: 0, max: 10, desc: '温差', type: 'number', hidden: false },
						maxdT: { desc: '最大温差', hidden: true, },
					}
				},
				lRh: { value: 90, unit: '%', conversion: 1, step: 0.01, min: 90, max: 95, desc: '相对湿度', type: 'number' },
				aRat: { value: 0.15, unit: '1', step: 0.01, conversion: 1, min: 0, max: 1, desc: '新风比', type: 'number' },
			}
		},
		outputSummberRes: {
			desc: '一次回风夏季输出',
			selected: true,
			templateno: 1,//默认
			Points: [],
			Lines: []
		},

		calcuSummer: function (inputParm_s_default, atm) {
			//这个搞一个转换就好了
			console.log('计算夏季');
			var q = inputParm_s_default.value.Q.value;
			var w = inputParm_s_default.value.W.value;
			var e = calcE(q, w)
			var nStatusUI = inputParm_s_default.value.nStatus
			var nStatus = nStatusUI.value//格式转换

			var wStatusUI = inputParm_s_default.value.wStatus;
			var wStatus = wStatusUI.value

			var lRh = this.inputSummberParm.value.lRh.value;//相对湿度
			var aRat = this.inputSummberParm.value.aRat.value;

			var plan = this.inputSummberParm.value.plan;//方案

			var l2Status = calcL2status(nStatus, e, lRh, atm);
			var l2StatusUI = { id: 6, desc: '最大温差机器露点', mark: 'l2', type: 'status', value: l2Status }

			var cStatus = calcC(aRat, nStatus, wStatus, atm)
			var cStatusUI = { id: 3, desc: '一次回风状态点', mark: 'c', type: 'status', value: cStatus }
			//this.outputSummberRes.Points.length=0
			//this.outputSummberRes.Lines.length=0;
			this.outputSummberRes.Points.splice(0)
			this.outputSummberRes.Lines.splice(0)

			this.outputSummberRes.Points.push(deepCopy(nStatusUI), deepCopy(wStatusUI), l2StatusUI, cStatusUI)
			var dh;//不同处理方式结果不同
			var g;
			if (plan.selected == 'dT') {
				var dT = plan.value.dT.value;//dn-do
				var oStatus = calcOstatus(nStatus, e, dT, atm);
				if (oStatus.errType) {
					console.log('计算夏季出错', oStatus);
					return false;
				}
				var oStatusUI = { id: 5, desc: '送风状态点', mark: 'o', type: 'status', value: oStatus }
				var l1Status = Calcu_24(lRh, oStatus.d, atm);
				var l1StatusUI = { id: 4, desc: '机器露点', mark: 'l1', type: 'status', value: l1Status }
				dh = Math.abs(oStatus.h - nStatus.h);
				g = calcG(q, dh);

				this.outputSummberRes.Points.push(oStatusUI, l1StatusUI)
				this.outputSummberRes.Lines.push(
					{ id: 3, desc: '冷却减湿', mark: '', G: g, dh: Math.abs(cStatus.h - l1Status.h), d: Math.abs(cStatus.d - l1Status.d), p1: cStatusUI, p2: l1StatusUI, isActive: false },
					{ id: 4, desc: '加热', mark: 'd', G: g, dh: Math.abs(oStatus.h - l1Status.h), d: Math.abs(oStatus.d - l1Status.d), p1: oStatusUI, p2: l1StatusUI, isActive: false },
					{ id: 5, desc: '等热湿线', mark: 'ε', G: g, dh: dh, d: Math.abs(oStatus.d - nStatus.d), p1: nStatusUI, p2: oStatusUI, isActive: false }
				)
				this.outputSummberRes.templateno = 1;
			} else if (plan.selected == 'maxdT') {
				dh = Math.abs(l2Status.h - nStatus.h);
				g = calcG(q, dh);
				this.outputSummberRes.Lines.push(
					{ id: 3, desc: '冷却减湿', mark: '', G: g, dh: Math.abs(cStatus.h - l2Status.h), d: Math.abs(cStatus.d - l2Status.d), p1: cStatusUI, p2: l2StatusUI, isActive: false },
					{ id: 5, desc: '等热湿线', mark: 'ε', G: g, dh: dh, d: Math.abs(nStatus.d - l2Status.d), p1: l2StatusUI, p2: nStatusUI, isActive: false }
				)
				this.outputSummberRes.templateno = 3;
			}

			this.outputSummberRes.Lines.push(
				{ id: 1, desc: '混合（外）', mark: '', G: aRat * g, dh: Math.abs(wStatus.h - cStatus.h), d: Math.abs(wStatus.d - cStatus.d), p1: wStatusUI, p2: cStatusUI, isActive: false },
				{ id: 2, desc: '混合（内）', mark: '', G: (1 - aRat) * g, dh: Math.abs(nStatus.h - cStatus.h), d: Math.abs(nStatus.d - cStatus.d), p1: nStatusUI, p2: cStatusUI, isActive: false }
			)
			return { G: g };//需要夏季的风量
		},

		//计算冬季
		inputWinterParm: {
			desc: '一次回风冬季补充输入',
			selected: true,
			isActive: false,
			value: {
				plan: {
					desc: '方案', type: 'select', selected: 'h', value: {
						h: { desc: '等焓', hidden: false, },
						t: { desc: '等温', hidden: true, },
					}
				},
				lRh: { value: 90, unit: '%', conversion: 1, step: 0.01, min: 90, max: 95, desc: '相对湿度', type: 'number' },
				aRat: { value: 0.15, unit: '1', step: 0.01, conversion: 1, min: 0, max: 1, desc: '最小新风比', type: 'number' },
			}
		},
		outputWinterRes: {
			desc: '一次回风冬季输出',
			selected: true,
			templateno: 1,//默认
			Points: [],
			Lines: []
		},
		calcuWinter: function (inputParm_w_default, g, atm) {
			console.log('计算冬季');
			var q = -inputParm_w_default.value.Q.value;//需要带一个负号（热负荷hn-h0）
			var w = inputParm_w_default.value.W.value;
			var nStatusUI = inputParm_w_default.value.nStatus;
			var nStatus = nStatusUI.value//格式转换
			var wStatusUI = inputParm_w_default.value.wStatus;
			var wStatus = wStatusUI.value
			var oStatus = calcOstatus2(nStatus, q, w, g, atm);
			var oStatusUI = { id: 5, desc: '送风状态点', mark: 'o', type: 'status', value: oStatus }

			var lRh = this.inputWinterParm.value.lRh.value;
			var l1Status = Calcu_24(lRh, oStatus.d, atm);
			var l1StatusUI = { id: 4, desc: '机器露点', mark: 'l1', type: 'status', value: l1Status }

			var aRat = this.inputWinterParm.value.aRat.value;
			var cpStatus = calcC(aRat, nStatus, wStatus, atm)//这是c'=cp
			var cpStatusUI = { desc: '最小回风状态点', mark: 'c\'', type: 'status', value: cpStatus }
			var c2Status = calcC2(l1Status.h, nStatus, wStatus, atm)
			var c2StatusUI = { id: 3, desc: '回风状态点', mark: 'c', type: 'status', value: c2Status }

			var aRat2 = calcRat(wStatus, nStatus, c2Status);

			this.outputWinterRes.Points.splice(0)
			this.outputWinterRes.Lines.splice(0)
			var line3, line4;//方案控制
			var cStatusUI;//有用的c(下面的代码主要计算c)
			//判断此时新风比是否大于最小新风比
			if (aRat2 >= aRat) {//这儿换成hc2》=hcp即可
				cStatusUI = c2StatusUI
				this.outputWinterRes.Lines.push(
					{ id: 1, desc: '混合（外）', G: aRat * g, dh: Math.abs(wStatus.h - c2Status.h), d: Math.abs(wStatus.d - c2Status.d), p1: wStatusUI, p2: c2StatusUI, isActive: false },
					{ id: 2, desc: '混合（内）', G: (1 - aRat) * g, dh: Math.abs(nStatus.h - c2Status.h), d: Math.abs(nStatus.d - c2Status.d), p1: nStatusUI, p2: c2StatusUI, isActive: false }
				);
				this.outputWinterRes.templateno = 1;
			} else {//需要加热
				var hw1 = nStatus.h - (nStatus.h - l1Status.h) / aRat;
				var w2Status = Calcu_45(wStatus.d, hw1, atm);//这个是加热后的室外空气点
				var w2StatusUI = { id: 6, desc: '再热后的室外状态点', mark: 'w2', type: 'status', value: w2Status }
				var c3Status = calcC(aRat, nStatus, w2Status, atm);//加热后的混合点
				var c3StatusUI = { id: 3, desc: '回风状态点', mark: 'c', type: 'status', value: c3Status }
				cStatusUI = c3StatusUI
				//this.outputWinterRes.Points.push(c3StatusUI,w2StatusUI);
				this.outputWinterRes.Lines.push(
					{ id: 6, desc: '（预热）', mark: 'd', G: g, dh: Math.abs(w2Status.h - wStatus.h), d: Math.abs(w2Status.d - wStatus.d), p1: wStatusUI, p2: w2StatusUI, isActive: false },
					{ id: 1, desc: '混合（外）', G: aRat * g, dh: Math.abs(w2Status.h - c3Status.h), d: Math.abs(w2Status.d - c3Status.d), p1: w2StatusUI, p2: c3StatusUI, isActive: false },
					{ id: 2, desc: '混合（内）', G: (1 - aRat) * g, dh: Math.abs(nStatus.h - c3Status.h), d: Math.abs(nStatus.d - c3Status.d), p1: nStatusUI, p2: c3StatusUI, isActive: false }
				);
				this.outputWinterRes.templateno = 2;
			}
			var plan = this.inputWinterParm.value.plan;//方案
			if (plan.selected == 'h') {//默认按照等焓值处理
				line3 = { id: 3, desc: '绝热加湿', mark: 'h', G: g, dh: Math.abs(cStatusUI.value.h - l1Status.h), d: Math.abs(cStatusUI.value.d - l1Status.d), p1: cStatusUI, p2: l1StatusUI, isActive: false }
				line4 = { id: 4, desc: '加热', mark: 'd', G: g, d: Math.abs(oStatus.d - l1Status.d), dh: Math.abs(oStatus.h - l1Status.h), p1: l1StatusUI, p2: oStatusUI, isActive: false }
			} else if (plan.selected == 't') {
				var eStatus = Calcu_04(cStatusUI.value.t, oStatus.d, atm);
				var eStatusUI = { id: 4, desc: 'c等温o等湿交点', mark: 'e', type: 'status', value: eStatus }
				l1StatusUI.id = 6;//设置它的id就可以了（bug）
				this.outputWinterRes.Points.push(eStatusUI)
				line3 = { id: 3, desc: '等温', mark: 't', G: g, dh: Math.abs(cStatusUI.value.h - eStatus.h), d: Math.abs(cStatusUI.value.d - eStatus.d), p1: cStatusUI, p2: eStatusUI, isActive: false };
				line4 = { id: 4, desc: '加热', mark: 'd', G: g, d: Math.abs(oStatus.d - eStatus.d), dh: Math.abs(oStatus.h - eStatus.h), p1: eStatusUI, p2: oStatusUI, isActive: false }
			}
			this.outputWinterRes.Points.push(deepCopy(nStatusUI), deepCopy(wStatusUI), oStatusUI, cStatusUI, cpStatusUI, l1StatusUI)
			var dh = Math.abs(oStatus.h - nStatus.h);
			this.outputWinterRes.Lines.push(
				line3, line4,
				{ id: 5, desc: '等热湿线', mark: 'ε', G: g, dh: dh, d: Math.abs(oStatus.d - nStatus.d), p1: oStatusUI, p2: nStatusUI, isActive: false }
			)
		}
	},
	{
		name: '二次回风',
		lable: '冬夏',
		desc: '二次回风计算方法，可以同时计算冬夏季的处理过程。冬夏季采用相同的总风量。',
		selected: false,
		calcu: function (inputParm_s_default, inputParm_w_default, atm) {
			console.log('二次回风atm=', atm);
			var res = this.calcuSummer(inputParm_s_default, atm);
			if (res) {//res={G:g,G2:g2,l2Status:l2Status};
				this.calcuWinter(inputParm_w_default, res, atm);
			}
		},
		//计算夏季
		inputSummberParm: {
			desc: '二次回风夏季补充输入',
			selected: true,
			isActive: false,
			value: {
				dT: { value: 2, unit: '℃', conversion: 1, step: 0.01, min: 0, max: 10, desc: '温差', type: 'number' },
				lRh: { value: 90, unit: '%', conversion: 1, step: 0.01, min: 90, max: 95, desc: '相对湿度', type: 'number' },
				aRat: { value: 0.15, unit: '1', step: 0.01, conversion: 1, min: 0, max: 1, desc: '新风比', type: 'number' },
			}
		},
		outputSummberRes: {
			desc: '二次回风夏季输出',
			selected: true,
			templateno: 1,//默认
			Points: [],
			Lines: []
		},

		calcuSummer: function (inputParm_s_default, atm) {
			console.log('计算夏季');
			var q = inputParm_s_default.value.Q.value;
			var w = inputParm_s_default.value.W.value;

			var nStatusUI = inputParm_s_default.value.nStatus
			var nStatus = nStatusUI.value//格式转换
			var wStatusUI = inputParm_s_default.value.wStatus;
			var wStatus = wStatusUI.value

			var lRh = this.inputSummberParm.value.lRh.value;//相对湿度
			var aRat = this.inputSummberParm.value.aRat.value;//新风比
			var dT = this.inputSummberParm.value.dT.value;//温差

			this.outputSummberRes.templateno = 4;
			//1.计算热湿比
			var e = calcE(q, w)
			//2.计算总风量（先计算送风状态点）
			var oStatus = calcOstatus(nStatus, e, dT, atm);
			if (oStatus.errType) {
				console.log('计算夏季出错', oStatus);
				return false;
			}
			var oStatusUI = { id: 5, desc: '（二次）送风状态点', mark: 'o', type: 'status', value: oStatus }
			var g = calcG(q, Math.abs(oStatus.h - nStatus.h));//kg/s
			//3.通过喷水室的风量（先计算机器露点l2）
			var l2Status = calcL2status(nStatus, e, lRh, atm);
			var l2StatusUI = { id: 4, desc: '机器露点', mark: 'l2', type: 'status', value: l2Status }
			var gl = calcG(q, Math.abs(l2Status.h - nStatus.h));//kg/s
			//4.二次回风量
			var g2 = g - gl;
			//5.新风量
			var gw = g * aRat;
			//6.一次回风量
			var g1 = gl - gw;
			//7.确定一次回风混合点
			var hc = (g1 * nStatus.h + gw * wStatus.h) / gl;
			var cStatus = calcC2(hc, nStatus, wStatus, atm);
			var cStatusUI = { id: 3, desc: '一次回风状态点', mark: 'c', type: 'status', value: cStatus }
			//8.计算热量（在模块中计算了）

			//9.添加结果
			this.outputSummberRes.Points.splice(0)
			this.outputSummberRes.Lines.splice(0)
			this.outputSummberRes.Points.push(deepCopy(nStatusUI), deepCopy(wStatusUI), cStatusUI, l2StatusUI, oStatusUI);
			this.outputSummberRes.Lines.push(
				{ id: 1, desc: '一次混合（外）', mark: '', G: gw, dh: Math.abs(wStatus.h - cStatus.h), d: Math.abs(wStatus.d - cStatus.d), p1: wStatusUI, p2: cStatusUI, isActive: false },
				{ id: 2, desc: '一次混合（内）', mark: '', G: g1, dh: Math.abs(nStatus.h - cStatus.h), d: Math.abs(nStatus.d - cStatus.d), p1: nStatusUI, p2: cStatusUI, isActive: false },
				{ id: 3, desc: '冷却减湿', mark: '', G: gl, dh: Math.abs(l2Status.h - cStatus.h), d: Math.abs(l2Status.d - cStatus.d), p1: cStatusUI, p2: l2StatusUI, isActive: false },
				{ id: 4, desc: '二次混合（外）', mark: '', G: gl, dh: Math.abs(l2Status.h - oStatus.h), d: Math.abs(l2Status.d - oStatus.d), p1: l2StatusUI, p2: oStatusUI, isActive: false },
				{ id: 5, desc: '二次混合（内）', mark: '', G: g2, dh: Math.abs(nStatus.h - oStatus.h), d: Math.abs(nStatus.d - oStatus.d), p1: nStatusUI, p2: oStatusUI, isActive: false },
				{ id: 6, desc: '等热湿线', mark: 'ε', G: g, dh: Math.abs(nStatus.h - oStatus.h), d: Math.abs(nStatus.d - oStatus.d), p1: oStatusUI, p2: nStatusUI, isActive: false }
			)
			return { G: g, G2: g2, l2Status: l2Status };
		},

		//计算冬季
		inputWinterParm: {
			desc: '二次回风冬季补充输入',
			selected: true,
			isActive: false,
			value: {
				plan: {
					desc: '方案', type: 'select', selected: 'l2', value: {
						l2: { desc: '冬夏季同机器露点', hidden: false, },
						g2: { desc: '冬夏季同二次回风量', hidden: true, },
					}
				},
				lRh: { value: 90, unit: '%', conversion: 1, step: 0.01, min: 90, max: 95, desc: '相对湿度', type: 'number' },
				aRat: { value: 0.15, unit: '1', step: 0.01, conversion: 1, min: 0, max: 1, desc: '最小新风比', type: 'number' },
			}
		},
		outputWinterRes: {
			desc: '二次回风冬季输出',
			selected: true,
			templateno: 1,//默认
			Points: [],
			Lines: []
		},
		calcuWinter: function (inputParm_w_default, summerRes, atm) {
			console.log('计算冬季');
			var q = -inputParm_w_default.value.Q.value;//需要带一个负号（热负荷hn-h0）
			var w = inputParm_w_default.value.W.value;
			var nStatusUI = inputParm_w_default.value.nStatus;
			var nStatus = nStatusUI.value//格式转换
			var wStatusUI = inputParm_w_default.value.wStatus;
			var wStatus = wStatusUI.value

			var aRatmin = this.inputWinterParm.value.aRat.value;
			var lRh = this.inputWinterParm.value.lRh.value;

			var g = summerRes.G;//总风量
			//1.计算送风状态点o
			var oStatus = calcOstatus2(nStatus, q, w, g, atm);
			var oStatusUI = { id: 6, desc: '送风状态点', mark: 'o', type: 'status', value: oStatus }
			//2.根据方案计算机器露点
			var l2Status;//机器露点
			var plan = this.inputWinterParm.value.plan;//方案
			if (plan.selected == 'l2') {//默认按照冬夏季机器露点相同处理
				l2Status = summerRes.l2Status;
			} else if (plan.selected == 'g2') {//冬夏季二次回风量相同
				var dl2 = oStatus.d - summerRes.G2 * (nStatus.d - oStatus.d) / (g - summerRes.G2);//式子中的oStatus.d==c2Status.d
				l2Status = Calcu_24(lRh, dl2, atm);
			}
			var l2StatusUI = { id: 4, desc: '机器露点', mark: 'l2', type: 'status', value: l2Status }
			//3.计算二次混合点c2（通过喷水室的风量、二次回风量）
			var c2Status = calcC3(oStatus.d, nStatus, l2Status, atm);
			var c2StatusUI = { id: 5, desc: '二次回风点', mark: 'c2', type: 'status', value: c2Status };
			var aRat2 = calcRat(l2Status, nStatus, c2Status);//二次回风回风比
			var g2 = g * aRat2;//二次回风量
			var gl = g - g2;//喷水室风量
			var gwmin = g * aRatmin;//最小新风量
			//4.计算一次混合点c1
			var c1Status, c1StatusUI;
			var cpStatus = calcC(gwmin / gl, nStatus, wStatus, atm)//这是c'=cp
			var cpStatusUI = { desc: '最小回风状态点', mark: 'c\'', type: 'status', value: cpStatus }
			c1Status = calcC2(l2Status.h, nStatus, wStatus, atm)
			c1StatusUI = { id: 3, desc: '一次回风状态点', mark: 'c1', type: 'status', value: c1Status }
			this.outputWinterRes.Points.splice(0)
			this.outputWinterRes.Lines.splice(0)
			var gw;//新风量

			if (c1Status.h <= cpStatus.h) {//说明不需要再热
				var aRat3 = calcRat(wStatus, nStatus, c1Status);//实际新风比=gwc/g
				gw = g * aRat3;
				this.outputWinterRes.Lines.push(
					{ id: 1, desc: '一次混合（外）', mark: '', G: gw, dh: Math.abs(wStatus.h - c1Status.h), d: Math.abs(wStatus.d - c1Status.d), p1: wStatusUI, p2: c1StatusUI, isActive: false }
				)
				this.outputWinterRes.templateno = 5;
			} else {
				gw = gwmin;
				var hw2 = nStatus.h - (nStatus.h - l2Status.h) * gl / gw;
				var w2Status = Calcu_45(wStatus.d, hw2, atm);//这个是加热后的室外空气点
				var w2StatusUI = { id: 7, desc: '再热后的室外状态点', mark: 'w2', type: 'status', value: w2Status }
				c1Status = calcC(gwmin / gl, nStatus, w2Status, atm);//加热后的混合点
				c1StatusUI = { id: 3, desc: '一次回风状态点', mark: 'c1', type: 'status', value: c1Status }
				this.outputWinterRes.Points.push(w2StatusUI);
				this.outputWinterRes.Lines.push(
					{ id: 1, desc: '一次混合（外）', mark: '', G: gw, dh: Math.abs(w2Status.h - c1Status.h), d: Math.abs(w2Status.d - c1Status.d), p1: w2StatusUI, p2: c1StatusUI, isActive: false },
					{ id: 8, desc: '预热', mark: 'd', G: gw, dh: Math.abs(w2Status.h - wStatus.h), d: Math.abs(w2Status.d - wStatus.d), p1: wStatusUI, p2: w2StatusUI, isActive: false }
				)
				this.outputWinterRes.templateno = 6;
			}
			var g1 = gl - gw;;//一次回风量

			//输出结果

			this.outputWinterRes.Points.push(deepCopy(nStatusUI), deepCopy(wStatusUI), c1StatusUI, l2StatusUI, c2StatusUI, oStatusUI);
			this.outputWinterRes.Lines.push(
				{ id: 2, desc: '一次混合（内）', mark: '', G: g1, dh: Math.abs(nStatus.h - c1Status.h), d: Math.abs(nStatus.d - c1Status.d), p1: nStatusUI, p2: c1StatusUI, isActive: false },
				{ id: 3, desc: '冷却减湿', mark: '', G: gl, dh: Math.abs(l2Status.h - c1Status.h), d: Math.abs(l2Status.d - c1Status.d), p1: c1StatusUI, p2: l2StatusUI, isActive: false },
				{ id: 4, desc: '二次混合（外）', mark: '', G: gl, dh: Math.abs(l2Status.h - c2Status.h), d: Math.abs(l2Status.d - c2Status.d), p1: l2StatusUI, p2: c2StatusUI, isActive: false },
				{ id: 5, desc: '二次混合（内）', mark: '', G: g2, dh: Math.abs(nStatus.h - c2Status.h), d: Math.abs(nStatus.d - c2Status.d), p1: nStatusUI, p2: c2StatusUI, isActive: false },
				{ id: 6, desc: '再热', mark: 'd', G: g2, dh: Math.abs(oStatus.h - c2Status.h), d: Math.abs(oStatus.d - c2Status.d), p1: c2StatusUI, p2: oStatusUI, isActive: false },
				{ id: 7, desc: '等热湿线', mark: 'ε', G: g, dh: Math.abs(nStatus.h - oStatus.h), d: Math.abs(nStatus.d - oStatus.d), p1: oStatusUI, p2: nStatusUI, isActive: false }
			)
		}
	}
];

export default calcuMethods;


// WEBPACK FOOTER //
// ./src/calcuMethods.js